export const getNomeAdvogado = (advogadoId, mapaUsuarios) => {
  return mapaUsuarios[String(advogadoId)]?.nome || "Desconhecido";
};